import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import RastreadorService from 'services/RastreadorService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
	pagination: {
		content: [],
		totalElements: 0,
		totalPages: 0,
		currentPage: 0,
		pageSize: 10,
	},
}

export const getAll = createAsyncThunk('rastreador/all',async () => {
    const response = await RastreadorService.all()
    return response;
})

export const getAllPaginated = createAsyncThunk('rastreador/allPaginated', async (params, { rejectWithValue }) => {
	try {
		const response = await RastreadorService.paginated(params)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar rastreadores')
	}
})

export const getDisponivel = createAsyncThunk('rastreador/disponivel',async () => {
    const response = await RastreadorService.disponivel()
    return response;
})

export const save = createAsyncThunk('rastreador/save',async (data, { rejectWithValue }) => {
	try {
		const response = await RastreadorService.save(data)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao salvar usuário')
	}
})

export const id = createAsyncThunk('rastreador/id',async (data, { rejectWithValue }) => {
	try {
		const response = await RastreadorService.id(data)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar rastreador')
	}
})

export const inativar = createAsyncThunk('rastreador/inativar',async (data, { rejectWithValue }) => {
	try {
		const response = await RastreadorService.inativar(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao inativar rastreador')
	}
})

export const ativar = createAsyncThunk('rastreador/ativar',async (data, { rejectWithValue }) => {
	try {
		const response = await RastreadorService.ativar(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao reativar rastreador')
	}
})

export const enviarSms = createAsyncThunk('rastreador/enviarSms',async (data, { rejectWithValue }) => {
	try {
		const response = await RastreadorService.enviarSms(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao enviar sms')
	}
})

export const enviarSmsManual = createAsyncThunk('rastreador/enviarSmsManual',async (data, { rejectWithValue }) => {
	try {
		const response = await RastreadorService.enviarSmsManual(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao enviar sms manual')
	}
})

export const enviarSmsEconomico = createAsyncThunk('rastreador/enviarSmsEconomico',async (data, { rejectWithValue }) => {
	try {
		const response = await RastreadorService.enviarSmsEconomico(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao enviar sms')
	}
})

export const enviarSmsNormal = createAsyncThunk('rastreador/enviarSmsNormal',async (data, { rejectWithValue }) => {
	try {
		const response = await RastreadorService.enviarSmsNormal(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao enviar sms')
	}
})

export const rastreadorSlice = createSlice({
	name: 'rastreador',
	initialState,
	reducers: {
		clearRastreadorEdicao: (state) => {
			state.edicao = null;
		  },
	},
    extraReducers: (builder) => {
		builder
			.addCase(getAll.pending, (state) => {
				state.loading = true
			})
			.addCase(getAll.fulfilled, (state, action) => {
				state.loading = false
				state.rastreadores = action.payload
			})
			.addCase(getAll.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(getAllPaginated.pending, (state) => {
				state.loading = true
			})
			.addCase(getAllPaginated.fulfilled, (state, action) => {
				state.loading = false
				state.pagination = {
					content: action.payload.content,
					totalElements: action.payload.totalElements,
					totalPages: action.payload.totalPages,
					currentPage: action.payload.number,
					pageSize: action.payload.size,
				}
			})
			.addCase(getAllPaginated.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(save.pending, (state) => {
				state.loading = true
			})
			.addCase(save.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/app/rastreador/default'
				state.edicao = null
			})
			.addCase(save.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(id.pending, (state) => {
				state.loading = true
			})
			.addCase(id.fulfilled, (state, action) => {
				state.loading = false
				state.edicao = action.payload
			})
			.addCase(id.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(getDisponivel.pending, (state) => {
				state.loading = true
			})
			.addCase(getDisponivel.fulfilled, (state, action) => {
				state.loading = false
				state.disponiveis = action.payload
			})
			.addCase(getDisponivel.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(inativar.pending, (state) => {
				state.loading = true
			})
			.addCase(inativar.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/app/cliente/default'
				state.edicao = action.payload
			})
			.addCase(inativar.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(ativar.pending, (state) => {
				state.loading = true
			})
			.addCase(ativar.fulfilled, (state) => {
				state.loading = false
			})
			.addCase(ativar.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(enviarSmsManual.pending, (state) => {
				state.loading = true
			})
			.addCase(enviarSmsManual.fulfilled, (state, action) => {
				state.loading = false
			})
			.addCase(enviarSmsManual.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
	},
})

export const {
	showLoading,
	clearRastreadorEdicao
} = rastreadorSlice.actions

export default rastreadorSlice.reducer